module.exports = __webpack_public_path__ + "static/media/othersIco.02247f03.svg";